import React from 'react';
import { AddCaseDetails } from 'pages/components';

const ARContactCasesNewDetails = (props) => (
  <AddCaseDetails {...props} />
);

export default ARContactCasesNewDetails;
